import yyglGetter from '../getters/yyglGetter'
import yyglAction from '../actions/yyglAction'
import yyglMutation from '../mutations/yyglMutation'

const yyglModule = {
  state: {
    approvellist: {},
    enterprise: {},
    enterpriseLearns: {},
    enterpriseTests: {},
    enterpriseEmployees: {},
    enterpriseZjyTestDetails: {},
    enterpriseZjyTestEmployeeRecord: {},
    enterpriseZjyTestEmployees: {},
    enterpriseBdyTestDetails: {},
    enterpriseBdyTestEmployees: {},
    enterpriseBdyTestEmployeeRecord: {},
    enterpriseDetails: {},
    enterpriseRegister: {},
    enterpriseApprove: {},

    learnApprove: {},
    learnApproveCount1: 0,
    learnApproveCount2: 0,
    learnApproveCount3: 0,
    jcyLearnApproveCount1: 0,
    jcyLearnApproveCount2: 0,
    makeUpApprove: {},
    makeUpApproveCount1: 0,
    makeUpApproveCount2: 0,
    makeUpApproveCount3: 0,
    pendingApprovalCount: 0,
    learningmgtYY: {},
    learningmgt: {},
    learningmgtEmployee: {},
    learningmgtEmployeeMockExamRecords: [],
    learningmgtEmployeeLesson: {},
    learningmgtEmployeeLessonCatalogs: [],
    learningMGTEmployeeLessonAlbumDetails: {},
    learningmgtEmployeeLessonLog: [],
    temployeeList: {},
    exportEmployeeExcel: {},
    learnApproveExportBdyExcel: {},
    learnApproveExportBdyZpZip: {},
    learnApproveExportBdyHzbExcel: {},
    learnApproveExportJsgrExcel: {},
    learnEnterprise: {},
    exportEmployeeZp: {},
    exportBdyExcel: {},
    exportJsgrExcel: {},
    yyHasCourse: {},
    learnapproveExportExcel: {},
    learnapproveExportEmployeeExcel: {},
    learnBdyBMExcel: {},
    exportMakeUpApproveExcel: {},
    exportMakeUpjfApproveExcel: {},
    testRooms: {},
    testRoom: {},

    testBatchs: {},
    testBatchDetails: {},
    courseTestBatchs: [],
    testBatchEmployees: {},
    testBatchAddEmployees: {},
    testBatchJobStats: [],
    testBatchEmployeeExcel: {},

    testTrains: {},
    courseTestTrains: [],
    testTrainDetails: {},
    testTrainEmployees: {},
    testTrainEmployeeExcel: {},
    testTrainLessonExcel: {},
    testTrainEmployeeZp: {},

    testSessionStates: [],
    testSessions: {},
    testSessionDetails: {},
    testSessionEmployeeAdmissionTicketUrl: {},
    testSessionEmployees: {},
    testSessionAddEmployees: {},
    testSessionEmployeeExcel: {},
    testSessionTestExcel: {},

    zjpxTrains: {},

    zjyTestBatchs: {},
    zjyTestBatchDetails: {},
    zjyTestBatchEmployees: {},
    zjyTestBatchApproveEmployees: {},
    zjyTestBatchApproveEmployeeCount: 0,

    enterprises: {},

    invoiceApproves: {},
    invoiceApproveCount: {},

    newsTestPlan: {},
    newsTestPlanTypes: [],

    newsCategorys: [],
    newsYY: {},

    employees: {},
    employeeDetails: {},
    employeeMnksLearns: [],
    employeeLearns: {},
    employeeTests: {},
    employeePractices: [],

    cert: {},
    certs: {},
    certStats: [],
    certSources: [],
    certDetails: {},

    jsgrTestBatchs: {},
    allJsgrTestBatchs: [],
    jsgrTestBatchJobStats: [],
    jsgrTestBatchEmployees: {},

    jsgrTestTrains: {},
    allJsgrTestTrains: [],
    jsgrTestTrainEmployees: {},
    jsgrTestTrainEmployeeExcel: {},
    jsgrTestTrainLessonExcel: {},

    jsgrTestSessions: {},
    jsgrTestSessionDetails: {},
    jsgrTestSessionEmployees: {},
    addJsgrTestSessionEmployees: {},
    jsgrTestSessionEmployeeExcel: {},

    bdyTestPlanBatchs: {},
    bdyTestPlanBatchJobStats: [],
    bdyTestPlanBatchSessions: {},

    bdyTestBatchs: {},
    bdyTestBatchJobStats: [],
    bdyTestBatchDetails: {},
    bdyTestBatchEmployeeExcel: {},

    bdyTestSessions: {},
    bdyTestSessionJobStats: [],
    bdyTestSessionDetails: {},
    bdyTestSessionEmployees: {},
    bdyTestSessionKcybExcel: {},
    bdyTestSessionEmployeeExcel: {},

    examBatchs: {},
    examBatchCourses: [],
    examBatchJobStats: [],
    examBatchDetails: {},
    examBatchEmployeeExcel: {},
    examBatchSpbExcel: {},

    examSessions: {},
    examSessionCourses: [],
    examSessionJobStats: [],
    examSessionDetails: {},
    examSessionEmployees: {},
    examSessionKcybExcel: {},
    examSessionEmployeeExcel: {},
    examSessionScoreTemplateExcel: {},
    examPaperDetails: {},
    examPaperApproves: [],
    examSessionEmployeeCert: {},

    enterpriseModifyApprovesYY: {},
    pendingModifyApprovalCount: {},

    bdyPracticeEnrolls: {},
    bdyPracticeEnrollApprovalCount: {},
    gbdyPracticeEnrollStates: [],
    bdyPracticeEnrollDetails: {},

    questionYYs: [],
    bdyQuestions: {},

    learnInvoices: {},
    learnInvoiceGkDKPCount: 0,
    learnInvoicePxDKPCount: 0,
    learnInvoiceDetails: {},
    learnInvoiceStates: [],
    learnInvoiceDpwj: {},
    learnInvoiceDpExcel: {},

    approveCertReplaces: {},
    certReplaceApproves: [],
    approveCertReplaceCount1: 0,
    approveCertReplaceCount2: 0,
    certReplaceApproveActions: [],

    allEmployeeChangeApproves: {}
  },
  getters: yyglGetter,
  actions: yyglAction,
  mutations: yyglMutation
};

export default yyglModule;



// WEBPACK FOOTER //
// ./src/store/jzjy/modules/yyglModule.js